import CookieManager from "../../common/business/CookieManager";

class NabaCookieManager extends CookieManager {
    constructor() {
        super();
    }
}

export default new NabaCookieManager();
